import React from 'react'
import { connect } from 'react-redux'
import { Breadcrumb } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'

import { contractPath } from 'routes'
import { MainBodyContent } from 'components'
import Information from '../Shareds/Information'
import Approve from '../Shareds/Approve'
import CommentHistory from '../Shareds/CommentHistory'
import ConditionOfPayment from '../Shareds/ConditionOfPayment'
import PaymentCondition from '../Shareds/PaymentCondition'
import TimeOfContract from '../Shareds/TimeOfContract'
import TypeOfContract from '../Shareds/TypeOfContract'
import ContactPerson from '../Shareds/Contact'
import Attachment from '../Shareds/Attachment'
import FinalContract from '../Shareds/FinalContract'
import VendorSignContract from '../Shareds/VendorSignContract'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import {
  getContractDetail,
  clearContractData,
  gethOptionContract,
  gethOptionTypeOfContract,
  gethPOCompleteDetail,
  gethOptionAOPT,
  getContractWorkflowViewMode
} from 'ducks/contract'
import { 
  getHrmsMembers,
  getAllMembers
} from 'ducks/member'

const ContractDetail = (props) => {

  const { 
    history, 
    contractDetail, 
    valueForm,
    poCompleteDetail,
    isDetail = true,
  } = props

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
    props.gethOptionContract()
    props.gethOptionAOPT()
    props.gethOptionTypeOfContract()
    if (match && match.params && match.params.contractId) {
      props.getContractDetail(match.params.contractId, history, false)
    }
    return (() => {
      props.clearContractData()
    })
  },[])

  React.useEffect(() => {
    if(props.contractId){
      props.getContractWorkflowViewMode(props.contractId)
    }
  }, [props.contractId])

  React.useEffect(()=>{
    if(valueForm&&valueForm.poId){
      props.gethPOCompleteDetail(valueForm.poId)
    }
  },[valueForm&&valueForm.poId])

  React.useEffect(()=>{
    if(Object.keys(poCompleteDetail).length){
      props.change('poSelectedNumber',`${poCompleteDetail.documentNumber} | ${poCompleteDetail.sapNumber} | ${poCompleteDetail.title}`)
    }
  },[poCompleteDetail])

  return (
    <MainBodyContent
      headerTitle={`Contract - ${contractDetail.documentNumber ? `#${contractDetail.documentNumber}` : 'Detail'}`}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={[
            { key: 'Contract', content: 'Contract', link: true, onClick: () => history.push(contractPath) },
            { key: 'Contract_Detail', content: 'Detail', active: true }
          ]}
        />
      }
    >
      {Object.keys(contractDetail).length?<DocumentStep documentDetail={contractDetail} approvers={props.contractWorkflowData.data} />:null}
      <Information isDetail/>
      {valueForm&&(valueForm.sn&&valueForm.status!=6)?
      <Approve history={history} handleSubmit={props.handleSubmit} data={contractDetail.data}/>:null}
      {Object.keys(contractDetail).length>0&&<TypeOfContract isDetail/>}
      <ConditionOfPayment isDetail/>
      <PaymentCondition isDetail/>
      <TimeOfContract isDetail/>
      <ContactPerson isDetail />
      <Attachment isDetail/>
      <FinalContract/>
      <VendorSignContract/>
      <br/>
      <CommentHistory/>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  let contractDetail = state.contract.contractDetail.data
  return ({
    initialValues: {
      paymentConditions:[],
      ...contractDetail
    },
    contractDetail,
    contractId: contractDetail.id,
    contractWorkflowData: state.contract.contractWorkflowData,
    poCompleteDetail:state.contract.poCompleteDetail.data,
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = {
  getContractDetail,
  clearContractData,
  gethOptionContract,
  gethOptionTypeOfContract,
  gethPOCompleteDetail,
  gethOptionAOPT,
  getContractWorkflowViewMode,
  getHrmsMembers,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formContract',
  enableReinitialize: true,
})(ContractDetail)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)